<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="dark" (click)="modalGC.dismiss(null, 'cancel')">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ category.type }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-text color="medium" class="ion-padding-horizontal ion-padding-top ion-display-block">
    Select a training, confirm the date completed, and then choose Save &amp; Submit.
  </ion-text>
  <ng-container *ngIf="!(trainingsFacade.isLoading$ | push); else skeletons">
    <ng-container *ngIf="(skillsAndExperience.claimableTrainingsForCurrentCategory$ | push)?.length; else emptyState">
      <ion-list>
        <ion-item *ngFor="let item of skillsAndExperience.claimableTrainingsForCurrentCategory$ | push">
          <ion-label [color]="isAdded(item) ? 'muted' : undefined">
            {{ item.label }}
          </ion-label>
          <ion-button
            mode="ios"
            slot="end"
            size="small"
            color="dark"
            fill="clear"
            *ngIf="isAdded(item)"
            data-cy="categorized-training-added-label"
          >
            <ion-icon slot="start" name="checkmark-circle"></ion-icon>
            Added!
          </ion-button>
          <ion-button
            mode="ios"
            slot="end"
            color="dark"
            size="small"
            *ngIf="!isAdded(item)"
            (click)="openDatePicker(popover, $event, item.value)"
          >
            Add
            <ion-icon slot="start" name="add"></ion-icon>
          </ion-button>
          <ion-popover side="left" #popover>
            <ng-template>
              <gc-datepicker-item
                [control]="claimDateControl"
                [autoOpen]="true"
                [hideField]="true"
                closeOn="select"
                placeHolder="Date Completed"
                max="today"
                (dismissed)="onDatePickerDismiss(popover, $event)"
              >
                <ion-label>Date Completed</ion-label>
              </gc-datepicker-item>
            </ng-template>
          </ion-popover>
        </ion-item>
      </ion-list>
    </ng-container>
  </ng-container>
  <ng-template #emptyState>
    <div class="alert alert__warning text-center ion-margin" data-cy="empty-categorized-training-list">
      No additional trainings are available to add for this category.
    </div>
  </ng-template>
  <ng-template #skeletons>
    <ion-item *ngFor="let i of [1, 2, 3]">
      <ion-label>
        <ion-skeleton-text animated style="width: 60%; height: 1em"></ion-skeleton-text>
      </ion-label>
    </ion-item>
  </ng-template>
</ion-content>
<ion-footer class="p-3">
  <ion-button
    mode="ios"
    color="dark"
    expand="block"
    [disabled]="!pendingClaims.length"
    (click)="submit()"
    data-cy="categorized-training-submit-button"
  >
    Save &amp; Submit
  </ion-button>
</ion-footer>
